import { Component } from '@angular/core';
import {Data,
  DataLoaderService, SummaryValidationService, SortingService,SummaryService, CommonDataService,ProgressBarService, PriceCalculationService
} from '../service-call-index';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component'
// import { promise } from 'protractor';

@Component({
  selector: 'summary-validation',
  templateUrl: './summary-validations.template.html',
  styleUrls: ['./summary-validations.component.css'],
})
export class SummaryValidationComponent {
  public addedMsgs: any;
  public deletedMsgs: any;
  public addedCodes: any;
  public deletedCodes: any;
  public icon = "gray";
  public urlFlag: string;
  private errorMessage: string;
  public colorOptions = [];
  public addColorOptions = [];
  public rim = [];
  public upholstery = [];
  public trim = [];
  public factoryOptions: Data[];
  public additionalColorOptions: Data[];
  public packageOptions: Data[];
  public localOptions: Data[];
  public localPackageOptions: Data[];
  public standardOptions: Data[];
  public options: any;


  constructor(private dataLoaderService: DataLoaderService, private alt: AlternateScreenComponent,
    private summaryValidationService: SummaryValidationService, private summaryService: SummaryService,
    private commonDataService: CommonDataService,private progressService: ProgressBarService,
    private sortingService: SortingService, private priceCalculationService:PriceCalculationService) {
      this.colorOptions = this.dataLoaderService.data.color;
      this.addColorOptions = this.dataLoaderService.data.additionalColor;
      this.rim = this.dataLoaderService.data.rim;
      this.upholstery = this.dataLoaderService.data.upholstery;
      this.trim = this.dataLoaderService.data.trim;
      this.factoryOptions = this.dataLoaderService.data.facOptions;
      this.packageOptions = this.dataLoaderService.data.packages;
      this.localOptions = this.dataLoaderService.data.options;
      this.localPackageOptions = this.dataLoaderService.data.localPackagesList;
      this.standardOptions = this.dataLoaderService.data.stdOpt;
  }

  ngOnInit() {
    this.urlFlag = this.dataLoaderService.vehicleInfo.urlFlag;
    if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' ) {
      this.options = "Color, Additional Color & Upholstery";
  }
  else {
      this.options = "Color & Upholstery";
  }
  }

  openSuccessMsg() {
    this.alt.amendUpdatedPrices();
    this.alt.removeCodesOnValidate(this.dataLoaderService.deletedCodes);
    this.dataLoaderService.flagDictionary.validated = true;
    this.sortingService.sortCodes(this.colorOptions, true)
    this.sortingService.sortCodes(this.addColorOptions, true)
    this.sortingService.sortCodes(this.rim, true)
    this.sortingService.sortCodes(this.upholstery, true)
    this.sortingService.sortCodes(this.trim, true)
    this.sortingService.sortCodes(this.factoryOptions, true)
    this.sortingService.sortCodes(this.localOptions, true)
    this.sortingService.sortCodes(this.packageOptions, true)
    this.sortingService.sortCodes(this.localPackageOptions, true)
    this.sortingService.sortCodes(this.standardOptions, true)
    for(let i in this.colorOptions){
      for(let j in this.upholstery){
      if(this.colorOptions[i].selected == true && this.upholstery[j].selected == true && this.dataLoaderService.flagDictionary.validated == true){
        this.commonDataService.progressBarColorFlag = true;
        this.commonDataService.acceptFlag = true;
        break;
      }
    }
    }
    if(this.commonDataService.progressBarColorFlag == true){
    setTimeout(() => {
      this.progressService.illuminateGreen();
      this.commonDataService.progressBarColorFlag = false;
      
    }, 0);
  }else{
    setTimeout(() => {
      this.progressService.illuminateRed();
      this.commonDataService.progressBarColorFlag = false;
    
    }, 0);
  }  
  if(this.commonDataService.progressBarColorFlag == true){
    this.dataLoaderService.flagDictionary.errorFlag = false;
     this.dataLoaderService.flagDictionary.successFlag = true;
    this.dataLoaderService.flagDictionary.summaryFlag = true;
    setTimeout(() => {
      this.progressService.illuminateGreen();
      this.commonDataService.progressBarColorFlag = false;
      
    }, 0);
    this.submitData();
  }
  else{
    this.dataLoaderService.flagDictionary.summaryFlag = true;
    this.dataLoaderService.flagDictionary.errorFlag = true;
    this.dataLoaderService.flagDictionary.successFlag = false;
  }
  }

  alternateOptionsForURLFlag2Accept() {
    if (this.dataLoaderService.flagDictionary.normalSummaryValidFlag) {
      this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
    }
     this.dataLoaderService.flagDictionary.loadingFlag = true;
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
    let returnValidateResponse = this.summaryValidationService.getSummaryValidationData();
    returnValidateResponse.subscribe(
      validateResponse => {
        if ((validateResponse.addedCodes && validateResponse.addedCodes.length > 0) || 
    (validateResponse.deletedCodes && validateResponse.deletedCodes.length > 0)) {
          this.dataLoaderService.addedCodes = validateResponse.addedCodes;
          this.dataLoaderService.addedMsgs = validateResponse.addedMsgs;
          this.dataLoaderService.deletedCodes = validateResponse.deletedCodes;
          this.dataLoaderService.deletedMsgs = validateResponse.deletedMsgs;
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = true;
          this.dataLoaderService.flagDictionary.loadingFlag = false;
          this.commonDataService.sendSuggestion(validateResponse);

        } else {
          this.alt.amendUpdatedPrices();
          this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
          this.dataLoaderService.flagDictionary.loadingFlag = false; 
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false; 
         
          setTimeout(() => {
            this.progressService.illuminateGreen();
          }, 0);
          this.dataLoaderService.flagDictionary.successFlag = true;
          this.dataLoaderService.flagDictionary.summaryFlag = true;
          this.dataLoaderService.flagDictionary.errorFlag = false;
          this.submitData();
        }
       
      }, err => {
        if (err._body !== undefined) {
          this.errorMessage = err._body;
          this.commonDataService.notifyErrorMsgItem(this.errorMessage);
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
          this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
          this.dataLoaderService.flagDictionary.loadingFlag = false;
        }
      });
  }

 alternateOptionsForURLFlag2Validate() {
    // return new Promise((resolve,reject)=>{
    if (this.dataLoaderService.flagDictionary.normalSummaryValidFlag) {
      this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
    }
     this.dataLoaderService.flagDictionary.loadingFlag = true;
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
    let returnValidateResponse = this.summaryValidationService.getSummaryValidationData();
    returnValidateResponse.subscribe(
      validateResponse => {
        if ((validateResponse.addedCodes && validateResponse.addedCodes.length > 0) || 
    (validateResponse.deletedCodes && validateResponse.deletedCodes.length > 0)) {
          this.dataLoaderService.addedCodes = validateResponse.addedCodes;
          this.dataLoaderService.addedMsgs = validateResponse.addedMsgs;
          this.dataLoaderService.deletedCodes = validateResponse.deletedCodes;
          this.dataLoaderService.deletedMsgs = validateResponse.deletedMsgs;
          //updating hiddenCodes
          this.dataLoaderService.hiddenOptions = validateResponse.hiddenCodes;
          // updating internalCodes
          this.dataLoaderService.amendInternalCodes = validateResponse.internalCodes;
          this.dataLoaderService.internalCodes = validateResponse.internalCodes;
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = true;
          this.dataLoaderService.flagDictionary.loadingFlag = false;
          this.dataLoaderService.flagDictionary.noAlternateInExpertMode = false;
          this.commonDataService.sendSuggestion(validateResponse);
          this.commonDataService.deselectFlag=true;
          
          setTimeout(() => {
            this.progressService.illuminateGreen();
          }, 0);

        } else {
          this.dataLoaderService.flagDictionary.noAlternateInExpertMode = true;
          this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
          this.dataLoaderService.flagDictionary.loadingFlag = false;
          this.dataLoaderService.flagDictionary.summaryFlag = true;
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
          this.dataLoaderService.flagDictionary.successFlag = true;
          this.dataLoaderService.flagDictionary.validated = true;
          this.dataLoaderService.flagDictionary.expertvalidated = true;
          this.dataLoaderService.flagDictionary.expertValidateFlag = false;
          this.commonDataService.deselectFlag=true;
          this.alt.amendUpdatedPrices();
          const color = this.summaryValidationService.getColor();
          const upholstery = this.summaryValidationService.getUpholstery();
          if(color !== undefined && upholstery != undefined){
            if(color.selected == true && upholstery.selected == true ){
              this.commonDataService.progressBarColorFlag = true;
              this.commonDataService.acceptFlag = true;
            }
          }
          if(this.commonDataService.progressBarColorFlag == true){  
            setTimeout(() => {
              this.progressService.illuminateGreen();
              this.commonDataService.progressBarColorFlag = false;
            }, 0);
        }else{
          setTimeout(() => {
            this.progressService.illuminateRed();
            this.commonDataService.progressBarColorFlag = false;
          }, 0);
        }        
        }
        this.priceCalculationService.normalModePriceCalculation();
        // resolve(true)
      }, err => {
        if (err._body !== undefined) {
          this.errorMessage = err._body;
          this.commonDataService.notifyErrorMsgItem(this.errorMessage);
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
          this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
          this.dataLoaderService.flagDictionary.loadingFlag = false;
        }
        // reject(false)
      });
    // });
  }

  changeIcon() {
    if (this.icon == "gray") {
      this.icon = "blue";
    }
    else {
      this.icon = "gray";
    }
     this.dataLoaderService.flagDictionary.validated = false;
   
  }
  submitData() {
    this.dataLoaderService.flagDictionary.loadingFlag = true;
    let configData = this.summaryService.submitData();
    console.log("configData ------ ",configData);
    this.dataLoaderService.flagDictionary.loadingFlag = false;
    
    (<HTMLInputElement>document.getElementById('acceptString')).value = configData + '';
    (<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
    (<HTMLFormElement>document.getElementById('form1')).submit();
  }
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/summary-validations/summary-validations.component.ts